import _Calendar from './Calendar';

import './style/index.js';

export * from './type';

export const Calendar = _Calendar;

export default Calendar;
